var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPokerSeats5(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 3,
    width: 14,
    height: 10,
    rx: 5,
    fill: "#E28354"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.93 8.194l-.937-.23.386-3.573h3.833v.996H7.355L7.16 7.13c.11-.065.264-.129.46-.19.194-.066.417-.098.668-.098.335 0 .635.055.899.166.266.107.493.265.678.473.186.206.327.456.425.752.098.293.147.624.147.992 0 .328-.05.636-.147.923a2.15 2.15 0 01-.43.756 1.976 1.976 0 01-.727.513c-.29.12-.633.18-1.03.18-.297 0-.582-.042-.855-.126a2.33 2.33 0 01-.727-.386 1.968 1.968 0 01-.518-.635 2.178 2.178 0 01-.225-.874h1.153c.029.231.092.428.19.591.101.16.234.282.4.366.167.085.359.127.577.127.198 0 .37-.034.512-.102a.97.97 0 00.357-.303c.097-.134.17-.29.215-.469.048-.179.073-.377.073-.596 0-.208-.028-.398-.083-.57a1.242 1.242 0 00-.24-.45 1.024 1.024 0 00-.395-.293 1.335 1.335 0 00-.552-.107c-.28 0-.494.04-.644.122a2.021 2.021 0 00-.41.302z",
    fill: "#000"
  })));
}
SvgPokerSeats5.displayName = 'PokerSeats5';
export default SvgPokerSeats5;